import type { CPU } from '../CPU';
import { PSW_Z, H_TI } from './constants';

export function opBITMOD(cpu: CPU): void {
  let src_index: number;
  const bit_in = 1 << cpu.impl_operands[1].value;
  if (cpu.impl_hint & H_TI) {
    src_index = cpu.impl_long_imm;
    cpu.impl_operands[0].value = cpu.mmu.read8(((cpu.regs.dsr << 16) | src_index) >>> 0);
  } else {
    src_index = cpu.impl_operands[0].value;
    cpu.impl_operands[0].value = cpu.regs.r[src_index];
  }

  cpu.impl_flags_changed |= PSW_Z;
  cpu.impl_flags_out = (cpu.impl_operands[0].value & bit_in) ? 0 : PSW_Z;

  switch (cpu.impl_opcode & 0x000F) {
    case 0:
      cpu.impl_operands[0].value |= bit_in;
      break;
    case 2:
      cpu.impl_operands[0].value &= ~bit_in;
      break;
  }

  if ((cpu.impl_opcode & 0x000F) !== 1) {
    if (cpu.impl_hint & H_TI)
      cpu.mmu.write8(((cpu.regs.dsr << 16) | src_index) >>> 0, cpu.impl_operands[0].value);
    else
      cpu.regs.r[src_index] = cpu.impl_operands[0].value;
  }
}
